export type EditablePlayerGender = 'male' | 'female';
export type PlayerGenderFormValue = EditablePlayerGender | '';
export type CoachGenderFormValue = 'Male' | 'Female' | '';

/** Normalizes API casing and clears legacy/unsupported values for editable forms. */
export function normalizePlayerGender(value?: string | null): PlayerGenderFormValue {
  const normalized = value?.trim().toLowerCase();
  return normalized === 'male' || normalized === 'female' ? normalized : '';
}

/** Keeps the coach form's existing title-case value convention. */
export function toCoachGenderFormValue(value?: string | null): CoachGenderFormValue {
  const normalized = normalizePlayerGender(value);
  if (!normalized) return '';
  return normalized === 'male' ? 'Male' : 'Female';
}

/** Formats persisted values for read-only UI, including legacy unspecified records. */
export function formatPlayerGender(value?: string | null): string {
  return toCoachGenderFormValue(value) || '--';
}
